(() => {
  if (window.backInStockNotifyLoaded) {
    return;
  }

  window.backInStockNotifyLoaded = true;

  const getModal = (id) => document.getElementById(id);

  const openModal = (modal) => {
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('back-in-stock-notify-open');

    const firstInput = modal.querySelector('input:not([type="hidden"])');
    if (firstInput) {
      firstInput.focus();
    }
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('back-in-stock-notify-open');
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-back-in-stock-open]');
    if (openButton) {
      event.preventDefault();
      openModal(getModal(openButton.getAttribute('data-back-in-stock-open')));
      return;
    }

    const closeButton = event.target.closest('[data-back-in-stock-close]');
    if (closeButton) {
      closeModal(closeButton.closest('[data-back-in-stock-modal]'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    document.querySelectorAll('[data-back-in-stock-modal]:not([hidden])').forEach(closeModal);
  });
})();
